import { format, getTime, formatDistanceToNow } from 'date-fns';
import { uz } from 'date-fns/locale';
import { fAddZero } from './format-number';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  const d = new Date(date);

  if (!date || Number.isNaN(d.getTime())) {
    return '';
  }

  return format(d, fm);
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';
  const d = new Date(date);

  if (!date || Number.isNaN(d.getTime())) {
    return '';
  }

  return format(d, fm, { locale: uz });
}

export function fTimestamp(date) {
  const d = new Date(date);

  if (!date || Number.isNaN(d.getTime())) {
    return '';
  }
  return getTime(d);
}

export function fTime(date) {
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${fAddZero(hours)}:${fAddZero(minutes)}`;
}

export function fToNow(date) {
  const d = new Date(date);

  if (!date || Number.isNaN(d.getTime())) {
    return '';
  }
  return formatDistanceToNow(d, {
    includeSeconds: true,
    addSuffix: true,
    locale: uz,
  });
}
